"use client";
import React from "react";
import styles from "./index.module.scss";

import VipIcon, { vipImagesMap } from "@/components/VipIcon";
import clsx from "clsx";

interface Props {
    level: number;
    vipIconStyle?: React.CSSProperties;
    vipIconClassName?: string;
    className?: string;
    style?: React.CSSProperties;
}

const Vip: React.FC<Props> = ({
    level,
    vipIconStyle = {},
    style = {},
    vipIconClassName = "",
    className = "",
}) => {
    const curVip = React.useMemo(() => {
        return vipImagesMap.get(level || 1);
    }, [level]);
    return (
        <div className={clsx(styles.vip, className)} style={{ ...style }}>
            <VipIcon
                style={{ ...vipIconStyle }}
                className={vipIconClassName}
                level={level}
            ></VipIcon>
            <div
                className={styles.vipText}
                style={{
                    background: `linear-gradient(to right,${curVip?.textBackground})`,
                    color: curVip?.textColor,
                }}
            >
                VIP {level}
            </div>
        </div>
    );
};

export default Vip;
